import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import { useState } from 'react';
import { Form } from 'react-bootstrap';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function ChartEvolucion({titulo, serie, tituloSerie, labels}) {

    const [tipoGrafico, setTipoGrafico] = useState("line");

    let quitarCerosEnSerie = function(serie) {

        let indexUltimoValorNoCero = serie.length-1;
        for (let i=serie.length-1; i>=0; i--) {
            if (serie[i] !== 0) {
                indexUltimoValorNoCero = i;
                break;
            }
        }
        return serie.slice(0, indexUltimoValorNoCero+1);
    }

    let seriePromedios = function(serie) {
        let seriePromedios = [];
        let acumulado = 0;
        for (let i=0; i<serie.length; i++) {
            acumulado += serie[i];
            seriePromedios.push(acumulado / (i + 1));
        }
        return seriePromedios;
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: titulo,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                min: 0
            }
        }
    };

    let serieSinCeros = quitarCerosEnSerie(serie);
    console.log(serieSinCeros);
    let labelsSinCeros = labels.slice(0, serieSinCeros.length);
    let seriePromediosSinCeros = seriePromedios(serieSinCeros);
    console.log(seriePromediosSinCeros);

    const data = {
        labels: labelsSinCeros,
        datasets: [
            {
                label: tituloSerie,
                data: serieSinCeros,
                fill: false,
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)'
            },
            {
                label: "Promedio "+tituloSerie,
                data: seriePromediosSinCeros,
                fill: false,
                borderColor: 'rgba(59, 145, 160, 0.5)',
                backgroundColor: 'rgba(59, 145, 160, 0.5)'
            }
        ],
    };

    return (
        <>
            {tipoGrafico === "line" ? (
                <Line data={data} options={options}/>
            ) : (
                <Bar data={data} options={options}/>
            )}
            <div className='mt-2' style={{ display: 'flex', justifyContent: 'center' }}>
                <Form>
                    <Form.Check // prettier-ignore
                        type="switch"
                        id="line-bar-switch"
                        onChange={() => setTipoGrafico(tipoGrafico === "line" ? "bar" : "line")}
                        checked={tipoGrafico === "bar"}
                        label="Gráfico de Barras"
                    />
                </Form>
            </div>
        </>
    );
}

export default ChartEvolucion;